<template>
  <div>
    <vs-breadcrumb>
      <li>
        <a aria-current="page" style="color: rgba(0, 0, 0, 0.4)" title="Setting"
          >Setting</a
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="textSuccess">Network</li>
    </vs-breadcrumb>

    <!-- <b-breadcrumb style="background-color: #ffffff; padding-left: 0px;">
    <b-breadcrumb-item active><h5>Setting</h5></b-breadcrumb-item>
    <b-breadcrumb-item active><h5>Network</h5></b-breadcrumb-item>
  </b-breadcrumb> -->
    <vs-card style="border-radius: 20px">
      <div class="mt-2" slot="header">
        <vs-row id="center">
          <h3 class="headerText">Network</h3>
          <vs-spacer />
          <btnPrint
            :dataList="networkList"
            :headerName="'Network'"
            :header="header"
          />
          <btnPDF
            :dataList="networkList"
            :headerName="'Network'"
            :header="header"
          />
          <btnExportXLSX
            :dataList="networkList"
            :headerName="'Network'"
            :header="header"
          />
          <vs-tooltip text="Add New Network" position="left">
            <h6>
              <vs-button
                color="success"
                style="border-radius: 20px"
                size="sm"
                icon="add"
                v-b-modal.addnetwork
                type="filled"
                >Add Network</vs-button
              >
            </h6> </vs-tooltip
          >&nbsp;&nbsp;
          <!-- <vs-button color="#007bff" type="line" icon="add" to="/createnetwork">Add New Network</vs-button> -->
        </vs-row>
      </div>

      <br />
      <div><NetworkList :key="componentKey" /></div>
    </vs-card>
    <b-modal
      id="addnetwork"
      no-close-on-backdrop="false"
      hide-header-close
      centered
      hide-footer
      size="lg"
    >
      <template #modal-title>
        <h4 style="color: #5fa74b">Create New Network</h4>
      </template>
      <div>
        <CreateNetwork />
      </div>
    </b-modal>
  </div>
</template>

<script>
import btnPrint from "../Page/Button/btnPrint.vue";
import btnPDF from "../Page/Button/btnPDF.vue";
import btnExportXLSX from "../Page/Button/btnExportXLSX.vue";
import NetworkList from "../dashboard/Network/NetworkList";
import CreateNetwork from "../Page/Subpage/CreateNetwork.vue";
import moment from "moment";
import XLSX from "xlsx"; // import xlsx
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
  name: "Network",
  data() {
    btndelnw: "";
    return {
      componentKey: 0,
      role: "",
      dataBody: [],
      dataExport: [],
      nwList: [],
      networkList: [],
      header: ["Name", "Gateway", "Sensors"],
    };
  },
  components: {
    NetworkList,
    CreateNetwork,
    btnPrint,
    btnPDF,
    btnExportXLSX,
  },
  methods: {
    forceRerender() {
      this.componentKey += 1;
    },
    // export xlsx
    onExport() {
      this.role = this.$session.get('role')
    console.log(this.role)
    this.$API.get('network/user').then((result)=>{
      this.nwList = result.data
      this.nwList.forEach(element => {
         this.dataExport.push({name: element.name,gateway: element.gwc,sensors: element.sc});
      });
      console.log(this.dataExport)
      const dataWS = XLSX.utils.json_to_sheet(this.dataExport)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb,'exportNetwork.xlsx')
      this.dataExport = [];
    })
      
    }
  },
  created() {
    this.role = this.$session.get('role')
    this.$API.get('network/user').then((result)=>{
      result.data.forEach(element => {
        this.networkList.push({name: element.name,gateway: element.gwc,sensors: element.sc});
      });
  })
  }
};
</script>
<style scoped>
.vs-button {
  border-radius: 20px;
}
button#dropdown-1_BV_toggle_.btn.dropdown-toggle.btn-secondary {
  border-radius: 5px;
}
th .sort-th .th-sort-icon {
  color: white;
  padding: 0px;
}
#p {
  display: inline;
}
#v {
  display: none;
}
#center {
  display: flex;
  align-items: center;
}
@media screen and (max-width: 600px) {
  .a {
    /* background: pink; */
    width: 200px;
  }
  #v {
    display: inline;
  }
  #p {
    display: none;
  }
  .vuesax-app-is-ltr .vs-table--search-input {
    width: 100px;
    padding: o;
  }
  .vuesax-app-is-ltr .vs-table--search i {
    left: 15px;
  }
}
</style>